module.exports = __webpack_public_path__ + "img/story026@2x.da32ec7f.png";